import PublicationLayouts from 'hb-builder/components/UIComponents/page/dynamic/Publication/PublicationLayouts';
import type { PublicationItemAttributes } from 'hb-builder/components/UIComponents/page/dynamic/Publication/types';
import {
  useRenderComponentsContext,
  useRendererContext,
} from 'hb-builder/hooks';
import type { RenderComponent } from 'hb-builder/types';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import { useFallbackNavigate } from 'hb-react/shared/hooks/useFallbackNavigate';
import { APP_TYPE } from 'hb-react/types/appType';

const Publication: RenderComponent = () => <div />; // never used

const Render = ({
  item,
}: {
  item: DocumentItem<PublicationItemAttributes>;
}) => {
  const {
    bodyWidth,
    isMobilePreview,
    ids,
    isPublic,
    networkRootUrl,
    whiteLabelUrl,
    workspaceConfig,
  } = useRendererContext();
  const { components } = useRenderComponentsContext();
  const { Section } = components;

  const { attributes } = item;
  const { type } = attributes?.dynamicAttributes || {};

  const navigate = useFallbackNavigate();

  if (!type || type === 'empty') {
    return null;
  }

  return (
    <Section.Render
      isMobilePreview={isMobilePreview}
      item={item}
      bodyWidth={bodyWidth}
      workspaceConfig={workspaceConfig}
    >
      <PublicationLayouts
        app={isPublic ? APP_TYPE.PUBLIC_OFFICE : APP_TYPE.FRONT_OFFICE}
        dynamicAttributes={attributes?.dynamicAttributes}
        ids={ids}
        isPublic={isPublic}
        navigate={navigate}
        networkRootUrl={networkRootUrl}
        type={type}
        whiteLabelUrl={whiteLabelUrl}
      />
    </Section.Render>
  );
};

Publication.componentName = 'Publication';
Publication.Render = Render;

export default Publication;
